var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationFollow(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3164,
    cy: 10,
    r: 9.75,
    fill: "#DDE5FF",
    stroke: "#0058B8",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5386 11.6C14.0727 11.6 15.3164 12.8312 15.3164 14.35V14.9C15.3164 15.5075 14.819 16 14.2053 16H6.42752C5.81387 16 5.31641 15.5075 5.31641 14.9V14.35C5.31641 12.8312 6.56006 11.6 8.09418 11.6H12.5386ZM10.3164 5C11.8505 5 13.0942 6.23122 13.0942 7.75C13.0942 9.26878 11.8505 10.5 10.3164 10.5C8.78228 10.5 7.53863 9.26878 7.53863 7.75C7.53863 6.23122 8.78228 5 10.3164 5Z",
    fill: "#0058B8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationFollow);
export default __webpack_public_path__ + "static/media/notification_follow.1c14c31f38aa97fcfd336840bfc804e5.svg";
export { ForwardRef as ReactComponent };